module.exports = __webpack_public_path__ + "media/images/vector-32@2x-6177bd997ecb3ee2f47cd1d27379f116.png";